const ParticleOptions = {
                    fullScreen: false,
                    fpsLimit: 30,
                    interactivity: {
                        events: {
                            onHover: {
                                enable: true,
                                mode: "repulse",
                            },
                            resize: true,
                        },
                        modes: {
                            bubble: {
                                distance: 400,
                                duration: 2,
                                opacity: 0.8,
                                size: 40,
                            },
                            repulse: {
                                distance: 100,
                                duration: 0.5,
                            },
                        },
                    },
                    particles: {
                        color: { value: "#66FCF1" },
                        links: {
                            color: "#ffffff",
                            distance: 150,
                            enable: true,
                            opacity: 0.5,
                            width: 2,
                        },
                        collisions: { enable: true },
                        move: {
                            direction: "none",
                            enable: true,
                            outModes: { default: "bounce" },
                            random: false,
                            speed: 2,
                            straight: false,
                        },
                        number: {
                            density: { enable: true, area: 900 },
                            value: 30,
                        },
                        opacity: { value: 0.7 },
                        shape: { type: "circle" },
                        size: { random: true, value: 4 },
                    },
                    detectRetina: true,
                }
export default ParticleOptions;